import { Unit } from "./Unit";
import { UnitSource } from "./NumberWithUnit";

export class UnitConversionFactor {
    private _id: string;
    private _factor: number;
    private _fromUnit: Unit;
    private _toUnit: Unit;

    constructor(factor: number, fromUnit: Unit, toUnit: Unit) {
        this.id = UnitConversionFactor.buildId(fromUnit, toUnit);
        this.factor = factor;
        this.fromUnit = fromUnit;
        this.toUnit = toUnit;
    }

    get id(): string {
        return this._id;
    }

    private set id(value: string) {
        this._id = value;
    }

    public static buildId(fromUnit: UnitSource, toUnit: UnitSource): string {
        const fromUnitAbbreviation = (fromUnit instanceof Unit) ? fromUnit.abbreviation : fromUnit;
        const toUnitAbbreviation = (toUnit instanceof Unit) ? toUnit.abbreviation : toUnit;
        return fromUnitAbbreviation + "_to_" + toUnitAbbreviation;
    }

    public get(): number {
        return this.factor;
    }

    public get factor(): number {
        return this._factor;
    }

    private set factor(value: number) {
        this._factor = value;
    }

    public get fromUnit(): Unit {
        return this._fromUnit;
    }

    private set fromUnit(value: Unit) {
        this._fromUnit = value;
    }

    public get toUnit(): Unit {
        return this._toUnit;
    }

    private set toUnit(value: Unit) {
        this._toUnit = value;
    }
}
